export const Color = {
    primaryColor: '#00908E',
    secondaryColor: '#004d40',
    tartiaryColor: '#092647',
    fourthColor: '#b8c419',
    bgHeaderColor: '#00908E',
    darkColor: '#00908E',
    bgPrimaryColor: '#FFFFFF',
    bgSecondaryColor: '#00908E',
    bgTartiaryColor: '#303030',
    bgFourthColor: '#e6e6e6',
    bgColorBlack: '#000000',
    textColor: '#303030',
    textColorWhite: '#FFFFFF',
    textColorBlack: '#000000',
    textColorGrey: '#e6e6e6',
    borderColor: '#f2f2f2',
    boxShadowInsetColor: 'rgba(0, 0, 0, 0.12)',
    boxShadowColor: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    overlayColor: 'rgba(0, 0, 0, 0.6)'
};